import { Col, Row } from 'antd'
import Form from 'app/components/Core/Login/Form'
import KLink from 'app/components/Modules/KLink'
import Button from 'app/components/UI-Elements/General/Button'
import { useFeedbacker } from 'app/lib/contexts/Feedbacker'
import { useSession } from 'app/lib/hooks/useCurrent'
import { useNextUrl } from 'app/lib/hooks/useNextUrl'
import useTranslation from 'app/lib/hooks/useTranslation'
import { HomepageURLBuilder } from 'app/lib/URLBuilder'
import { PageProps } from 'app/pages/typing'
import { Routes } from 'app/routes/Routes'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const portalId = 'login-portal-id'

const registerUrl = new HomepageURLBuilder().register().toString()
const productCatalogUrl = new HomepageURLBuilder().mieten().toString()

const Login: React.FC<PageProps> = ({ route }) => {
  const { nextUrl } = useNextUrl()
  const { tRoute } = useTranslation({ scope: route.key })
  const { authenticationErrors } = useSession()
  const { toastify } = useFeedbacker()

  useEffect(() => {
    if (nextUrl && authenticationErrors?.[0]) {
      toastify({ content: authenticationErrors[0], type: 'error' })
    }
  }, [authenticationErrors])

  const onSuccess = () => {
    window.location.replace(nextUrl || '')
  }

  return (
    <Row gutter={[0, 24]}>
      <Col span={24}>
        <Form onSuccess={onSuccess} portalId={portalId} />
      </Col>
      <Col span={24}>
        <Row justify="space-between">
          <Col>
            <Link to={`${Routes.Authentication.collection().forgot_password}?next_url=${nextUrl}`}>
              {tRoute({ id: 'forgot_password' })}
            </Link>
          </Col>
          <Col>
            <div id={portalId} />
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <Row justify="space-between" className="mt-4">
          <Col span={24}>
            <h2>{tRoute({ id: 'no_account' })}</h2>
          </Col>
          <Col>
            <KLink to={registerUrl} external blank={false}>
              <Button type="secondary" size="large">
                {tRoute({ id: 'create_account' })}
              </Button>
            </KLink>
          </Col>
          <Col>
            <KLink to={productCatalogUrl} external blank={false}>
              <Button type="secondary" size="large">
                {tRoute({ id: 'skip_login' })}
              </Button>
            </KLink>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default Login
